import React from 'react';
import { X, Loader2 } from 'lucide-react';

const BestMixturesModal = ({ isOpen, onClose, mixtures = [], isLoading = false }) => {
  if (!isOpen) return null;

  // Helper function to format CO2 text with subscript
  const formatCO2 = (text) => {
    return text.replace('CO2', 'CO<sub>2</sub>');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[80vh] relative flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Alle Mischgüter</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="overflow-y-auto flex-grow">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-8">
              <Loader2 className="h-8 w-8 animate-spin text-green-600 mb-2" />
              <p className="text-gray-700">Daten werden geladen...</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-gray-500 border-b">
                    <th className="text-left pb-4 font-medium">Asphaltmischgut</th>
                    <th className="text-left pb-4 font-medium">Projekt</th>
                    <th className="text-left pb-4 font-medium">vs. 1990</th>
                    <th className="text-left pb-4 font-medium">GWP</th>
                  </tr>
                </thead>
                <tbody>
                  {mixtures.map((mixture, index) => (
                    <tr key={mixture.id || index} className="border-b border-gray-100 hover:bg-gray-50">
                      <td className="py-4 font-medium">{mixture.name}</td>
                      <td className="py-4 text-gray-600">{mixture.category}</td>
                      <td className="py-4 text-green-600 font-medium">
                        {mixture.stock}
                      </td>
                      <td className="py-4" dangerouslySetInnerHTML={{ __html: formatCO2(mixture.sales) }} />
                    </tr>
                  ))}
                </tbody>
              </table>
              
              {mixtures.length === 0 && !isLoading && (
                <div className="text-center py-8 text-gray-500">
                  Keine Daten verfügbar
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BestMixturesModal;
